const storeDataTransfer = (dataTransfer) => {
  const items = {};
  for (let i = 0; i < dataTransfer.types.length; i++) {
    const type = dataTransfer.types[i];
    const data = dataTransfer.getData(type);
    if (typeof data !== "string") continue;
    items[type] = data;
  }
  return {
    items
  };
};
const restoreDataTransfer = (storedDataTransfer) => {
  const dataTransfer = new DataTransfer();
  for (const type in storedDataTransfer.items) {
    dataTransfer.setData(type, storedDataTransfer.items[type]);
  }
  return dataTransfer;
};

export { restoreDataTransfer, storeDataTransfer };
//# sourceMappingURL=index.js.map
